module.exports = __webpack_public_path__ + "static/img/logo170x140.a69db2f.png";